import React, { useEffect } from 'react'
import TimelineItem from 'redesign/components/organisms/timeline-item/timeline-item'
import type { IonContent } from '@ionic/core/components/ion-content'
import { getBadgeProps } from './get-badge-props'
import { Container } from './styles'
import type { TimelineProps } from './types'

const Timeline: React.FC<TimelineProps> = ({ items, isOffice = false }) => {
  useEffect(() => {
    const mainParent = document.getElementById('ionContent') as IonContent

    mainParent?.scrollToBottom()
  }, [])

  return (
    <Container>
      {items.map(({ id, title, status, avatarData, content, reminder }, index, list) => {
        const isLast = index === list.length - 1
        const badgeProps = getBadgeProps({ isOffice, badgeType: content?.badge })

        return (
          <TimelineItem
            badgeProps={badgeProps}
            status={status}
            key={id}
            title={title}
            avatarData={avatarData}
            content={content}
            isLast={isLast}
            reminder={reminder}
            isOffice={isOffice}
            id={id}
          />
        )
      })}
    </Container>
  )
}

export default Timeline
